<h4 *ngIf="title">{{title}}</h4>
<ng-template [ngIf]="spesaLegaleForm">
  <form #f="ngForm" [formGroup]="spesaLegaleForm" (ngSubmit)="update();">
    <div class="row" *ngIf="tipoPetitium === idPetitumQuantificabile" >
      <div datePickerInput class="col-sm-4"
      [labelInput]="'Data inizio calcolo Interessi '" formControlName="dataInizioCalcoloInteressi"
      [(ngModel)]="request.dataInizioCalcoloInteressi" [mandatory]="true"></div>
    </div>
    <div class="row">
      <div comboModInput class="col-sm-4"
           [labelInput]="'Tipo giudizio'"
           formControlName="tipoGiudizio"
           [objectReference]="request.tipoGiudizio"
           [ngModel]="request.tipoGiudizio"
           (onReturn)="request.tipoGiudizio = $event"
           [optionsCombo] ="optionTipoGiudizio"
           [mandatory]="true"></div>

      <div comboModInput class="col-sm-4"
           [labelInput]="'Grado'"
           formControlName="grado"
           [objectReference]="request.grado"
           [ngModel]="request.grado"
           (onReturn)="request.grado = $event"
           [optionsCombo] ="optionGrado"
           [noOrder]="true"
           [mandatory]="true"></div>

      <div textInputCurrency class="col-sm-4" [labelInput]="'Importo'" [control]="spesaLegaleForm.controls['importo']"
           [location]="'default'" formControlName="importo" [(ngModel)]="request.importo"
           [mandatory]="true"></div>

    </div>

    <div class="row">
      <p class="mandatory col-sm-12">
        <em>* Campi obbligatori</em>
      </p>
    </div>
    <div class="row">
      <p class="col-sm-3 col-xs-6">
        <button type="button" class="btn btn-outline-secondary btn-block"
                (click)="createForm();">Reset</button>
      </p>
      <p
        submitButton [disabled]="!spesaLegaleForm.valid"
        class="col-sm-3 col-xs-6 col-sm-offset-6"
        [labelButton]="'Salva'"></p>
    </div>
  </form>
</ng-template>

